import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export default function ModalCenter2(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Lavanderia Valentim Negri
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Ops!!</h4>
        <p>
          Parece que você não inseriu os dados incorretamente, o campo de nome e
          depoimento só aceitam letras e não é permitido que sejam enviadas em
          branco, verique esses campos e tente novamente.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  );
}
